export default __webpack_public_path__ + "static/media/sn.9860f4c7.svg";